
import '@/assets/scss/index.scss'
import dayjs from 'dayjs'
import _ from 'lodash'
import { commonfunc } from '~/mixin/common'
import { cmnMsStr } from '~/mixin/ms/msMixin'
import ScrMsg0021 from '~/pages/ms/msg/SCR_MSG_0021.vue'
import { pdMixin } from '@/mixin/pd/pdMixin'
import StoreUnitCard from '~/components/common/address/StoreUnitCard.vue'
import AddPickupStr from '~/components/common/modal/AddPickupStr.vue'
import NoData from '~/components/common/template/NoData.vue'
import TotalCount from '~/components/common/sort/TotalCount.vue'

export default {
  components: {
    TotalCount,
    AddPickupStr,
    StoreUnitCard,
    ScrMsg0021,
    NoData
  },
  mixins: [commonfunc, cmnMsStr, pdMixin],
  props: {
    returnUrl: {
      type: String,
      default: ''
    },
    isPkupStr: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      outerVisible: false,
      srchForm: {
        mbMngNo: this.$store.getters['session/getMbMngNo'],
        keyword: '',
        srchYn: 'N',

        geolocationAgrYn: 'N',
        curLttd: 0.0,
        curLitd: 0.0,

        currentPage: 1,
        pageSize: 100
      },
      pkupStr: [],
      strList: [],
      totalCnt: 0,
      selectedIndex: null,
      noStrTxt: '픽업 가능한 매장만 검색됩니다.',
      addStoreVisible: false,
      pkupStrList: [],
      recentDvya: {},
    }
  },
  watch: {
    'geoData.flag' (val) {
      this.srchForm.geolocationAgrYn = this.geoData.geolocationAgrYn
      this.srchForm.curLttd = this.geoData.strLttd
      this.srchForm.curLitd = this.geoData.strLitd

      this.selPkupStrList()
    },
    outerVisible (data) {
      if (data) {
        // 위치정보수집동의여부 조회
        // this.selGeolocationAgrYn()
        // 기본픽업매장 조회
        this.selPkupStrList()
        // 최근픽업매장조회
        this.selRecentDvya()
        if (!this.isPkupStr) {
          this.addStoreVisible = true
          this.outerVisible = false
        }
      } else {
        this.srchForm.keyword = ''
        this.strList = []
        this.geoData.flag = null
      }
    }
  },
  mounted () {
    // 위치정보수집동의여부 조회
    this.selGeolocationAgrYn()
  },
  methods: {
    selGeolocationAgrYn () {
      this.selGeolocation()
      this.srchForm.geolocationAgrYn = this.geoData.geolocationAgrYn
      this.srchForm.curLttd = this.geoData.strLttd
      this.srchForm.curLitd = this.geoData.strLitd
    },

    selPkupStrList () {
      this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('/mb/mbc/selPkupStrList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            this.pkupStrList = res.data.data
            this.$EventBus.$emit('intTotalCnt', this.pkupStrList[0]?.totalCnt, this.pkupStrList[0]?.intCnt)

            this.pkupStrList = this.convertStatusStoreList(this.pkupStrList)
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    upBassPkupStrYn (item, type) {
      if (!this.isLogin && this.returnUrl !== '') {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.returnUrl } })
        return
      }
      if (this.isNotEmpty(item)) {
        this.$AxiosBuilder
          .data(item)
          .build()
          .post('/mb/mbc/upBassPkupStr')
          .then((res) => {
            if (this.isNotEmpty(res.data.data)) {
              this.$emit('getStoreData', item)
              if (type !== 'del') {
                this.outerVisible = false
                this.addStoreVisible = false
              }
              this.selPkupStrList()
            }
          })
          .catch((err) => {
            console.log('error')
            console.log(err)
          })
      }
    },

    delPkupStr (item) {
      this.$AxiosBuilder
        .data(item)
        .build()
        .post('/mb/mbc/delPkupStr')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            if (res.data.success) {
              if (item.bassPkupStrYn === 'Y' && this.pkupStrList.length > 1) {
                this.upBassPkupStrYn(this.pkupStrList[1], 'del')
              }
              if (this.pkupStrList.length <= 1) {
                this.$emit('getStoreData')
              }
              this.selPkupStrList()
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },

    selRecentDvya () { // 최근픽업매장조회
      const param = {
        orNo: '',
        dlvFomCd: '',
        gfYn: '',
        status: '',
        currentPageCnt: 1,
        strtDt: dayjs().month(dayjs().month() - 12).format('YYYYMMDD'),
        endDt: dayjs().format('YYYYMMDD'),
        orStsCd: '',
        rowNumber: '',
        currentPage: 1, // 페이지 번호 현재 페이지 번호를 나타냄
        pageSize: 1, // 페이지 사이즈 기본 10
        orTyCd: '02' // 주문 유형
      }
      this.$AxiosBuilder
        .data(param)
        .build()
        .post('/or/orb/selOr')
        .then(async (res) => {
          const result = res.data
          if (result.success) {
            const recentDvya = await this.callApi('/or/orb/orDts/selOrDtl', { orNo: result.data[0].orNo })
            this.recentDvya = recentDvya
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },

    async callApi (url, params) {
      return await this.$AxiosBuilder
        .data(params)
        .build()
        .post(url)
        .then((res) => {
          return res.data.data
        })
    },

    // 매장상세조회팝업
    strDtl (strCd) {
      this.$refs.msg0021.strCd = strCd
      this.$refs.msg0021.outerVisible = true
    },

    addStore (item, idx) {
      this.upBassPkupStrYn(item)
    },

    getCurrentTime () {
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    convertStatusStoreList (arr) {
      const currentTime = this.getCurrentTime()
      return _.map(arr, (item) => {
        if (!_.isEmpty(item.opngTime) && !_.isEmpty(item.clsngTime) && _.isEmpty(item.hldyDt)) {
          if (currentTime >= item.opngTime && currentTime <= item.clsngTime) {
            return { ...item, status: 'status' }
          } else {
            return { ...item, status: 'off' }
          }
        } else if (!_.isEmpty(item.hldyDt)) {
          return { ...item, status: 'close' }
        }
        return item
      })
    },
  }
}
